import "../Components/Components.css";

import ModalSend from "../Components/ModalSend";
import ModalCancel from "../Components/ModalCancel";
import { useState } from "react";
import { useEffect } from "react";
import DataUserLoyalty from "../store/DataUserLoyalty";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

const UserReservations = observer(() => {
    const navigation = useNavigate();
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        if (
            localStorage.getItem("user") == "undefined" ||
            localStorage.getItem("user") == null
        ) {
            navigation(
                `/userLoyalty/registration${
                    DataUserLoyalty.placeId
                        ? `?place_id=${DataUserLoyalty.placeId}`
                        : ""
                }`
            );
        }
    }, []);
    function closeModal() {
        console.log("hello");

        setShowModal(false);
    }
    return (
        <>
            {showModal ? <ModalCancel closeModal={closeModal} /> : ""}
            <div className='px-[16px] py-[20px]  relative z-0'>
                <p className='main-text'>Все бронирования </p>
                <div className='borderGray mb-[14px] z-0'>
                    <p className='text-left text-[16px] font-[600]'>
                        12.12.2025
                    </p>
                    <p className='text-left text-[14px] mb-[14px]'>
                        12:00 / Летняя терраса №1, Гостей: 1, Продолжительность:
                        1 ч
                    </p>
                    <div className='flex justify-start'>
                        <button
                            className=' border-[1px] border-gray-500 px-[15px] py-[3px] rounded-[4px]'
                            onClick={() => setShowModal(true)}>
                            Отменить
                        </button>
                    </div>
                </div>
                <div className='borderGray'>
                    <p className='text-left text-[16px] font-[600]'>
                        12.12.2025
                    </p>
                    <p className='text-left text-[14px] mb-[14px]'>
                        12:00 / Летняя терраса №1, Гостей: 1, Продолжительность:
                        1 ч
                    </p>
                    <div className='flex justify-start'>
                        <button
                            className=' border-[1px] border-gray-500 px-[15px] py-[3px] rounded-[4px]'
                            onClick={() => setShowModal(true)}>
                            Отменить
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
});

export default UserReservations;
